/**
 * Exponential backoff for re-establishing a terminated GraphQL stream —
 * 2s, 4s, 8s… capped at 60s. Same shape as the `projectUpdated` recovery
 * added in TA-10117 / TA-10670, extracted so the schedule is testable on its
 * own and so every caller that needs it shares one ceiling.
 *
 * Callers: the chat-list `watchQuery` observable in `ChatsData` after a
 * terminal `error` (TA-10876), and the `chatUpdate` subscription after a
 * fatal WS close (TA-10877). Nothing here is chat-specific — it is
 * `Math.min(base * 2 ** attempt, max)` and nothing more.
 *
 * `attempt` is zero-based: attempt 0 is the delay before the first retry.
 */
export const RESUBSCRIBE_BASE_DELAY_MS = 2000;
export const RESUBSCRIBE_MAX_DELAY_MS = 60_000;

export const resubscribeDelayMs = (attempt: number): number =>
  Math.min(
    RESUBSCRIBE_BASE_DELAY_MS * 2 ** Math.max(0, attempt),
    RESUBSCRIBE_MAX_DELAY_MS
  );
